import React from 'react'
import styled from 'styled-components'
import { colors, _ } from 'utils'

const S = {
    NoData: styled.div`
        width: 100%;
        margin: 40px 0 20px 0;
        text-align: center;
        font-size: 24px;
        line-height: 28px;
        color: ${colors.icon};
        opacity: 0.5;
    `,
}

const NoData = ({ text = _('list.no_data') }: { text?: string }) => (
    <S.NoData>
        {text}
    </S.NoData>
)

export default NoData
